import script from "./NotificationsPageCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsPageCreator.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsPageCreator.vue?vue&type=style&index=0&id=7c564438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c564438"]])

export default __exports__